import { extractNodeProps, findHeaderNodes, findLinkNodes } from './index';

export const getLocalNavItems = ({ id, nodes }) =>
  findHeaderNodes(nodes)(id).map(node => ({
    ...extractNodeProps(node, { inLocalNav: true }),
    links: findLinkNodes(nodes, node.id).map(linkNode =>
      extractNodeProps(linkNode, { inLocalNav: true }),
    ),
  }));

export const getLocalNavTitle = ({ threadTitle, localNavNode }) => {
  const localNavCustomTitle =
    localNavNode?.properties?.metadataDecorations?.[0]?.payload;

  if (localNavCustomTitle?.localNavTitleStyle !== 'custom') {
    return threadTitle;
  }
  return localNavCustomTitle?.customTitle?.trim();
};
